









import { Component, Vue, Prop } from 'vue-property-decorator';
import BlockItem from './BlockItem.vue';

@Component({
  components: {
    BlockItem
  }
})
export default class BlockBox extends Vue {
  @Prop({ default: () => [] }) private list: any;
  @Prop() private type: string;
}
